import { Box } from "@mui/material";
import ProductForm from "../../components/ProductForm";

interface EditProductFieldsProps {
  businessType: string;
  formData: any;
  handleInputChange: (field: string, value: any) => void;
  categories: any[];
  staffList: any[];
  previewImage?: string | null;
  showReorderPosition?: boolean;
  barcodeId?: string;
  barcodeMode?: boolean;
  scanMode?: boolean;
  onToggleScan?: () => void;
  onBarcodeDetected?: (barcode: string) => void;
  isLoading?: boolean;
  hasChanges?: boolean;
  isFormValid?: boolean;
  removeEmojis?: (str: string) => string;
  formatAmount?: (value: string) => string;
  getCategoryInitials?: (categoryName: string) => string;
  updateProductNameWithCategory?: (productName: string, categoryId: string) => string;
}

const EditProductFields = ({ 
  businessType, 
  formData, 
  handleInputChange, 
  categories, 
  staffList, 
  previewImage, 
  showReorderPosition = false,
  barcodeId = "",
  barcodeMode = false,
  scanMode = false,
  onToggleScan = () => {},
  onBarcodeDetected = () => {},
  ...rest
}: EditProductFieldsProps) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 2 }}>
      <ProductForm
        formData={formData}
        categories={categories}
        staffMembers={staffList}
        businessType={businessType}
        onChange={handleInputChange}
        previewImage={previewImage}
        showErrors={formData?.submitted || false}
        showReorderPosition={showReorderPosition}
        barcodeId={barcodeId}
        barcodeMode={barcodeMode}
        scanMode={scanMode}
        onToggleScan={onToggleScan}
        onBarcodeDetected={onBarcodeDetected}
      />
    </Box>
  );
};

export default EditProductFields;